import {View, Sync} from 'MWC';
import Model from '../models/corezoid.m.js';
import tpl from '../templates/interactive.jsx';
import queries from '../queries/corezoid.q';
import {apiback} from '../../../config';
const data = {
    contactPhoneNumber: '+38 (0'
};

const hashData = {
    tap_to_phone: '72FA32SAA97B3122',
    default: '546B0B5BC97BE94B',
    energy_credit: '546B0B5BC97BE94B'
};

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            activeScreen: 'form',
            model: new Model(props.attribute)
        };
        this.sendSimpleForm = this.sendSimpleForm.bind(this);
        this.sendTsoForm = this.sendTsoForm.bind(this);
        this.attribute = this.props.attribute;
        this.entity = this.props.entity || 'legal';
        this.query = queries;
    }

    handleChange = event => {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    };

    selectItem = name => {
        const model = this.getModel();
        const data = {
            name: name,
            value: !model.fields.agree.value
        };

        this._run(data);
    };

    onBlurHandle = name => {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    };

    _run = data => {
        const model = this.getModel(),
            {name, value} = data;

        model.run({name, value});
        this.setState({model});
    };

    handleEscape = event => {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    };

    closeModal = event => {
        event ? event.stopPropagation() : this.props.closeModal();

        const target = event && event.target,
            classesToClose = ['form-wrapper', 'close-bth'];

        if (target && classesToClose.some(className => target.classList.contains(className))) {
            this.props.closeModal();
        }
    };

    sendForm = async () => {
        const model = this.getModel();
        const data = {
            phone: model.fields.contactPhoneNumber.value,
            name: model.fields.customerName.value,
            attribute: this.attribute,
            entity: this.entity,
            hash: this.attribute ? hashData[this.attribute] : hashData.default,
            // хеши по которым на беке определяется в какой конвеер пихать запрос
            ...this.props.calcData
        };

        if (this.attribute === 'energy_credit') {
            data.site = window.location.href;
        }
        if (this.attribute === 'leasing') {
            data.company = model.fields.companyName.value;
            data.sum = model.fields.sum.value;
        }
        if (
            this.attribute === 'deposits_business' ||
            this.attribute === 'light-house' ||
            this.attribute === 'yuo'
        ) {
            data.okpo = model.fields.okpo.value;
        }
        await this.query.sendForm(data);
        const activeScreen = this.query.activeScreen;
        this.setState({activeScreen});
    };

    sendSimpleForm = async () => {
        const model = this.getModel();
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: this.removeBracketsAndSpaces(model.fields.contactPhoneNumber.value),
                        attribute: this.attribute,
                        utm_source: 'site'
                    },
                    hash: '5FD3S0GF48F131DD'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.setState({activeScreen: 'success'});
            }
        } catch (error) {
            this.setState({activeScreen: 'error'});
            return error;
        }
    };

    sendEsgForm = async () => {
        const model = this.getModel();
        if (!model.isValid) return;
        const url = apiback('API_ESG_APPEAL');
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    phoneNumber: this.removeBracketsAndSpaces(
                        model.fields.contactPhoneNumber.value
                    ),
                    message: model.fields.message.value
                })
            });
            if (!response.ok) {
                throw new Error();
            }
            this.setState({activeScreen: 'success'});
        } catch (error) {
            this.setState({activeScreen: 'error'});
            return error;
        }
    };

    sendTsoForm = async () => {
        const model = this.getModel();
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: this.removeBracketsAndSpaces(model.fields.contactPhoneNumber.value),
                        name: model.fields.customerName.value,
                        address: model.fields.adress.value,
                        company: model.fields.companyName.value,
                        agree: model.fields.agree.value,
                        attribute: this.attribute
                    },
                    hash: '1BF2X4MC83H312DA'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.setState({activeScreen: 'success'});
            }
        } catch (error) {
            this.setState({activeScreen: 'error'});
            return error;
        }
    };

    removeBracketsAndSpaces(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '');

        phoneNumber = phoneNumber.replace(/\s/g, '');

        return phoneNumber;
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
    }

    static displayName = 'Green.Card.Order';
}
